import { Alert, Typography } from 'shared/ui'
import { getFormattedEndDate } from 'shared/lib/timeCalculations'
import { type IAlertAction, type IAlertProps } from 'shared/ui/Alert/types'

type IGracePeriodAlertProps = {
  importNumbersStatus: {
    durationHours: number
    startedAt: string
  }
  actions?: IAlertAction[]
  rightActions?: IAlertAction[]
  className?: IAlertProps['className']
}

export const GracePeriodAlert = ({
  importNumbersStatus,
  actions,
  rightActions,
  className,
}: IGracePeriodAlertProps) => {
  const { durationHours, startedAt } = importNumbersStatus

  return (
    <Alert
      className={className}
      item={{
        type: 'warning',
        title: `You're in a ${durationHours}-hour license grace period`,
        desc: (
          <Typography ariaLabel={'GracePeriodAlert'} variant={'body-md-regular'}>
            Assign, move, or delete numbers before {getFormattedEndDate(startedAt, durationHours)}.
            The grace period ends early if your licenses match your numbers. After that, unpaid
            licenses will be charged automatically.
          </Typography>
        ),
      }}
      actions={actions}
      rightActions={rightActions}
    />
  )
}
